import Image from "next/image"
import telegramImg from "public/images/social/telegram.png"
import whatsappImg from "public/images/social/whatsapp.png"
import baleImg from "public/images/social/bale.png"




const Social = () => {
    return (
        <ul className="flex align-i-center gap-15">
            <li>
                <a href="#">
                    <Image
                        src={whatsappImg}
                        alt="whatsapp logo"
                        width={25}
                        height={25}
                    />
                </a>
            </li>

            <li>
                <a href="#">
                    <Image
                        src={telegramImg}
                        alt="telegram logo"
                        width={25}
                        height={25}
                    />
                </a>
            </li>

            <li>
                <a href="#">
                    <Image
                        src={baleImg}
                        alt="bale logo"
                        width={25}
                        height={25}
                    />
                </a>
            </li>
        </ul>
    )
}

export default Social